export default {
  title: 'Ordre nr. {{number}}',
  labels: {
    item: '{{count}} vare',
    item_other: '{{count}} varer',
  },
  buttons: {
    details: 'Detaljer',
  },
  fulfillment_statuses: {
    created: 'Oprettet',
    reviewed: 'Gennemgået',
    accepted: 'Accepteret',
    preparing: 'Tilberedes',
    ready: 'Klar',
    on_delivery: 'Under levering',
    picked: 'Afhentet',
    rejected: 'Afvist',
  },
};
